import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Api\AdEventController::events
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/events'
*/
export const events = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: events.url(options),
    method: 'post',
})

events.definition = {
    methods: ["post"],
    url: '/api/events',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\AdEventController::events
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/events'
*/
events.url = (options?: RouteQueryOptions) => {
    return events.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\AdEventController::events
* @see app/Http/Controllers/Api/AdEventController.php:13
* @route '/api/events'
*/
events.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: events.url(options),
    method: 'post',
})

const ad = {
    events: Object.assign(events, events),
}

export default ad